import { createApp } from 'vue';
import { vMaska } from 'maska/vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import loadFonts from './plugins/webfontloader';
import vuetify from './plugins/vuetify';

loadFonts();

const pinia = createPinia();

const app = createApp(App);
app.use(pinia);
app.use(vuetify);
app.directive('maska', vMaska);
app.mount('#app');
